import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../utils/helpers/model.helper';
import { File } from '../files/file.model';

export const ATTACHMENT_SCHEMA = Object.freeze({
    TITLE: null, // ''
    DESCRIPTION: null, // ''
    FILE: File,
  }),
  RECORD = generateSchema(ATTACHMENT_SCHEMA),
  KEYS: any = generateKeys(ATTACHMENT_SCHEMA);

export class Attachment extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));

    const selfModel = setInModel(this, [
      {
        key: KEYS.FILE,
        value: new File(this.file),
      },
    ]);

    return selfModel as Attachment;
  }

  get id() {
    return this.file.id;
  }

  get title() {
    return this.get(KEYS.TITLE);
  }

  get description() {
    return this.get(KEYS.DESCRIPTION);
  }

  get file(): File {
    return this.get(KEYS.FILE);
  }

  get fileUrl(): string {
    return this.file.url;
  }

  setFile(file: File): Attachment {
    return this.set(KEYS.FILE, file) as Attachment;
  }

  setInfoFields(props?: any): Attachment {
    const attachment: any = setInModel(this, [
      {
        key: KEYS.TITLE,
        value: props.get(KEYS.TITLE),
      },
      {
        key: KEYS.DESCRIPTION,
        value: props.get(KEYS.DESCRIPTION),
      },
    ]);

    return attachment as Attachment;
  }
}
